/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";
import {SupplierId} from "./supplierId.zod";

export const SupplierRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["engineering.suppliers"]),
    resourceId: SupplierId,
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type SupplierRealtimeChange = zod.input<typeof SupplierRealtimeChange>;
export type SupplierRealtimeChangeOutput = zod.output<typeof SupplierRealtimeChange>;
